import { put, call } from "redux-saga/effects";
import { activeError, activeSuccess } from "~/components/Messages/actions";
import http from "~/utils/config/http";
import oauth from "~/utils/oauth";

import {
  setCadernosEncargos,
  setNewCadernoEncargos,
  errorCadernoEncargos,
  setCvs,
  setNewCvs,
  errorCVS,
  setGenerateCVPrompt,
  setSaveCvMgrLoading,
  setSpecificCv,
  setUpdateCv,
  setCreatedCv,
  setCreateEncargo,
  setSpecificEncargo,
  setUpdateEncargo,
  setProfilesByEncargo,
} from "./actionTypes";

export function* getCadernosEncargos() {
  try {
    const resp = yield http.get(`api/cvmgr/caderno-encargos/list`);
    yield put(setCadernosEncargos(resp.data));
  } catch (e) {
    yield put(setCadernosEncargos([]));
  }
}

export function* getProfilesByEncargo({ encargo }) {
  try {
    const resp = yield http.get(`api/cvmgr/caderno-encargos/${encargo.id}`);
    const profiles = [
      {
        id: 4,
        nome: "Manuel Gomes Cardoso",
        dominio: "Topografia; Cartografia; SIG",
        anosExperiencia: 39,
        grauAcademico: "Curso de Topografia",
        expInternacional: true,
        expProjFinanciados: false,
        linguas: "Português C2; Espanhol C1; Inglês B1; Francês B1",
        matchLevel: 40,
      },
      {
        id: 5,
        nome: "Alexandra Muati",
        dominio: "Geologia; Engenharia Geológica",
        anosExperiencia: 4,
        grauAcademico: "Mestre em Engenharia Geológica e de Minas",
        expInternacional: true,
        expProjFinanciados: false,
        linguas: "Português C2; Inglês C1; Espanhol B1",
        matchLevel: 50,
      },
      {
        id: 6,
        nome: "Alexandra Muati",
        dominio: "Geologia; Engenharia Geológica",
        anosExperiencia: 4,
        grauAcademico: "Mestre em Engenharia Geológica e de Minas",
        expInternacional: true,
        expProjFinanciados: false,
        linguas: "Português C2; Inglês C1; Espanhol B1",
        matchLevel: 85,
      },
      {
        id: 7,
        nome: "Alexandra Muati",
        dominio: "Geologia; Engenharia Geológica",
        anosExperiencia: 4,
        grauAcademico: "Mestre em Engenharia Geológica e de Minas",
        expInternacional: true,
        expProjFinanciados: false,
        linguas: "Português C2; Inglês C1; Espanhol B1",
        matchLevel: 89,
      },
      {
        id: 8,
        nome: "Alexandra Muati",
        dominio: "Geologia; Engenharia Geológica",
        anosExperiencia: 4,
        grauAcademico: "Mestre em Engenharia Geológica e de Minas",
        expInternacional: true,
        expProjFinanciados: false,
        linguas: "Português C2; Inglês C1; Espanhol B1",
        matchLevel: 30,
      },
    ];

    // Adiciona profiles em cada entrada de perfisProfissionais
    const perfisProfissionais = (resp.data.perfisProfissionais || []).map(
      (item) => ({
        ...item,
        profiles,
      })
    );

    // Junta perfisProfissionais atualizado ao restante dos dados
    const respToRetunr = { ...resp.data, perfisProfissionais };

    yield put(setProfilesByEncargo(respToRetunr));
  } catch (e) {
    yield put(setProfilesByEncargo({}));
    yield put(activeError(true, "getProfilesByEncargo"));
  }
}

export function* getSpecificEncargo({ id }) {
  try {
    const resp = yield http.get(`api/cvmgr/caderno-encargos/${id}`);
    yield put(setSpecificEncargo(resp?.data));
  } catch (e) {
    yield put(setSpecificEncargo({}));
    yield put(activeError(true, "getSpecificEncargo"));
  }
}

export function* updateEncargo({ payload }) {
  try {
    yield http.post(`api/cvmgr/caderno-encargos/update/${payload.id}`, payload);
    yield put(setUpdateEncargo(true, "success"));
  } catch (e) {
    yield put(setUpdateEncargo(true, "error"));
    yield put(activeError(true, "updateEncargo"));
  }
}

export function* createNewCadernoEncargos({ payload }) {
  try {
    yield http.post(`api/cvmgr/save/caderno-encargos`, payload);
    yield put(setCreateEncargo(true, "success"));
    yield put(setNewCadernoEncargos({}));
    yield call(getCadernosEncargos);
  } catch (e) {
    yield put(setNewCadernoEncargos({}));
    yield put(setCreateEncargo(true, "error"));
    yield put(errorCadernoEncargos(true, "newCvs"));
  }
}
// export function* createNewCadernoEncargos({ payload }) {
//   try {
//     const resp = yield http.post(`api/cvmgr/extract/caderno-encargos`, payload);

//     // Mapeamento do resp.data para o formato desejado
//     const meta = resp?.data?.metadata || {};

//     yield put(setCreateEncargo(true, "success"));
//     yield put(setNewCadernoEncargos(meta));
//     yield call(getCadernosEncargos);
//   } catch (e) {
//     yield put(setNewCadernoEncargos({}));
//     yield put(setCreateEncargo(true, "error"));
//     yield put(errorCadernoEncargos(true, "newCvs"));
//   }
// }

export function* getCvs() {
  try {
    const resp = yield http.get(`api/cvmgr/cv/list`);
    yield put(setCvs(resp?.data));
  } catch (e) {
    yield put(setCvs([]));
  }
}

export function* getSpecificCv({ id }) {
  try {
    const resp = yield http.get(`api/cvmgr/cv/${id}`);
    yield put(setSpecificCv(resp?.data));
  } catch (e) {
    yield put(setSpecificCv({}));
    yield put(activeError(true, "getSpecificCv"));
  }
}

export function* updateCv({ payload }) {
  try {
    yield http.post(`api/cvmgr/cv/update/${payload.id}`, payload);
    yield put(setUpdateCv(true, "success"));
  } catch (e) {
    yield put(setUpdateCv(true, "error"));
    yield put(activeError(true, "updateCv"));
  }
}

export function* createNewCVS({ payload }) {
  try {
    yield http.post(`api/cvmgr/save/cv`, payload);
    yield put(setCreatedCv(true, "success"));
    yield put(setNewCvs({}));
    yield call(getCvs);
  } catch (e) {
    yield put(setNewCvs({}));
    yield put(setCreatedCv(true, "error"));
    yield put(errorCVS(true, "newCvs"));
  }
}
// export function* createNewCVS({ payload }) {
//   try {
//     const resp = yield http.post(`api/cvmgr/extract/cv`, payload);

//     // Mapeamento do resp.data para o formato desejado
//     const meta = resp?.data?.metadata || {};

//     yield put(setCreatedCv(true, "success"));
//     yield put(setNewCvs(meta));
//     yield call(getCvs);
//   } catch (e) {
//     yield put(setNewCvs({}));
//     yield put(setCreatedCv(true, "error"));
//     yield put(errorCVS(true, "newCvs"));
//   }
// }

export function* generateCVPrompt({ items, desc = null }) {
  const token = oauth.getAccessToken();
  try {
    yield put(setSaveCvMgrLoading(true));
    const datasetItems = Object.entries(items).map(([key, value]) => ({
      key,
      value,
    }));
    const body = { datasetItems, documentDesc: desc };
    const resp = yield call(http.post, "/api/openai/generate/prompt", body, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put(setGenerateCVPrompt(resp.data));
  } catch (e) {
    yield put(setGenerateCVPrompt(""));
    yield put(setSaveCvMgrLoading(false));
  }
}
